import React from 'react';
import { Star } from 'lucide-react';
import { testimonials } from '../mockData';
import { Card, CardContent } from './ui/card';

const Testimonials = () => {
  return (
    <section id="testimonials" className="py-20 bg-[#F0F0F0]">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-black mb-6">
            <span className="text-[#ED1C24]">apa kata-kata mereka yang udah join SBE</span>
          </h2>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-7xl mx-auto">
          {testimonials.map((testimonial) => (
            <Card key={testimonial.id} className="bg-white border-2 border-gray-200 hover:border-[#ED1C24] transition-all hover:shadow-xl group">
              <CardContent className="p-6">
                <div className="flex items-center justify-between mb-4">
                  <div className="flex space-x-1">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <Star key={i} className="w-5 h-5 fill-[#ED1C24] text-[#ED1C24]" />
                    ))}
                  </div>
                </div>
                <p className="text-gray-700 mb-4 leading-relaxed">
                  "{testimonial.message}"
                </p>
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 bg-[#ED1C24] rounded-full flex items-center justify-center text-white font-bold">
                    {testimonial.name.charAt(0)}
                  </div>
                  <div>
                    <p className="font-semibold text-black">{testimonial.name}</p>
                    <p className="text-sm text-gray-500">Indikator SBE User</p>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
        
        <div className="text-center mt-12">
          <div className="inline-flex items-center space-x-2 bg-white rounded-full px-6 py-3 border-2 border-[#ED1C24]">
            <Star className="w-5 h-5 fill-[#ED1C24] text-[#ED1C24]" />
            <span className="font-bold text-black">4.9/5</span>
            <span className="text-gray-600">dari 627+ pengguna aktif</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;